interface PercentageDiscountPreviewProps {
  percentageDiscount: number
}

export const PercentageDiscountPreview: React.FC<PercentageDiscountPreviewProps> = ({ percentageDiscount }) => {
  if (percentageDiscount <= 0) {
    return null
  }

  return <div className="z-pill bg-nelo-red font-inter absolute top-2 right-2 rounded-full px-2 py-1 text-xs font-bold text-white">-{percentageDiscount}%</div>
}
